import React from 'react'
import styled, { useTheme } from 'styled-components'

import { Container, Flex } from '../../styleguide/layout'
import { P } from '../../styleguide/typography'

// images
import arrowLeftCenter from '../../../assets/arrow-left-center.png'
import arrowRightCenter from '../../../assets/arrow-right-center.png'

const Info = () => {

  const theme = useTheme()

  return (
    <Container>
        <Flex 
          width="100%" 
          minh="368px" 
          bg={theme.colors.primary} 
          borderRadius="1rem"
          margin="0 0 2rem 0"
          direction="column"
          justify="center"
          items="center"
          padding="0 1rem"
          style={{ position: "relative" }}
        >
          <P color={theme.colors.white} align="center" maxWidth="600px">
            With Mula wallet you can easily load your wallet 
            with your local currency, buy and Hodl crypto currencies 
            that we support, chat with end-to-end encryption and make 
            transfers of funds to anyone, anywhere and anytime.
          </P>

          <Flex items="center" justify="center" gap="2rem" gapMobile="1rem" margin="3rem 0 0 0">
            <DottedList>
              <div className='dot' />
              <div className='text'>FAST</div>
            </DottedList>
            <DottedList>
              <div className='dot' />
              <div className='text'>secure</div>
            </DottedList>
            <DottedList>
              <div className='dot' />
              <div className='text'>transparent</div>
            </DottedList>
          </Flex>
          <PosImage className="left" src={arrowLeftCenter} alt="arrow" />
          <PosImage className="right" src={arrowRightCenter} alt="arrow" />
        </Flex>
    </Container>
  )
}

export default Info

const DottedList = styled.div`
  display: flex;
  align-items: center;
  gap: .75rem;

  .dot {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: ${props => props.theme.colors.secondary};
  }

  .text {
    font-size: 1.2rem;
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    color: ${({ theme }) => theme.colors.white}; 
    text-transform: uppercase;
  }

  @media (max-width: 768px) {
    gap: .5rem;

    .dot {
      width: .75rem;
      height: .75rem;
    }

    .text {
      font-size: .875rem;
    }
  }
`

const PosImage = styled.img`
	position: absolute;
	bottom: 3rem;
	width: 6rem;
	height: auto;

  &.left {
    left: 20rem;
  }

  &.right {
    right: 20rem;
  }

	@media (max-width: 768px) {
		display: none;
	}
`